module.exports = __webpack_public_path__ + "img/more-one-join.cbb631da.jpg";